import { IntervalDates, IntervalISOString } from './types'
import { addMinutes, startOfMinute } from 'date-fns'

export const DURATION_MINUTE = 60000
export const DURATION_FIVE_MINUTES = 300000
export const DURATION_HOUR = 3600000
export const DURATION_DAY = 86400000
export const DURATION_MINS_HOUR = 60
export const DURATION_MINS_DAY = 1_440

export function normaliseIntervalToDates(
  interval: IntervalISOString | IntervalDates
): IntervalDates {
  return {
    start: new Date(interval.start),
    end: new Date(interval.end),
  }
}

export function normaliseIntervalToIso(
  interval: IntervalISOString | IntervalDates
): IntervalISOString {
  return {
    start:
      typeof interval.start === 'string'
        ? interval.start
        : interval.start.toISOString(),
    end:
      typeof interval.end === 'string'
        ? interval.end
        : interval.end.toISOString(),
  }
}

export function fromIsoIntervalToDates(
  interval: IntervalISOString
): IntervalDates {
  return {
    start: new Date(interval.start),
    end: new Date(interval.end),
  }
}

export function intervalFromDuration(
  start: Date,
  duration: number
): IntervalDates {
  return {
    start: start,
    end: addMinutes(startOfMinute(start), duration),
  }
}
